import { Card } from "react-bootstrap";
import { FaTasks } from "react-icons/fa";
import { GoGoal } from "react-icons/go";
import { LuCalendarHeart } from "react-icons/lu";
import { FaLocationDot } from "react-icons/fa6";
import { ControlTranslation } from "AlignComponents";

const Events = () => {
  return (
    <div className="widget events">
      <Card>
        <Card.Header>
          <Card.Title>
            <LuCalendarHeart size={18} className="icon" />
            <ControlTranslation system={true} controlId="lblevents" />
          </Card.Title>
        </Card.Header>
        <Card.Body>
          {/* <div className="tasks">
            <div className="task">
              <div>
                <div className="text mb-1">
                  <h6>
                    Happy Birthday Celebration for Sarah Ahmed
                  </h6>
                  <span>
                    Join us in celebrating Sarah Ahmed’s birthday with cake, ...
                  </span>
                  <span>
                    <FaLocationDot size={14} />  Cafeteria, 2nd Floor
                  </span>
                </div>
                <div className="badge bg-info fs-8">
                  Monday, 12 Nov 2024 (6:00 PM)
                </div>
              </div>
              <div className="ms-auto">
                <div className="badge bg-outline-primary">
                  Notify
                </div>
              </div>
            </div>

            <div className="task">
              <div>
                <div className="text mb-1">
                  <h6>
                    Leadership Skills Development Workshop
                  </h6>
                  <span>
                    A half-day workshop designed to enhance leadership and...
                  </span>
                  <span>
                    <FaLocationDot size={14} />  Conference Hall A, Main Office
                  </span>
                </div>
                <div className="badge bg-info fs-8">
                  Monday, 12 Nov 2024 (8:00 PM)
                </div>
              </div>
              <div className="ms-auto">
                <div className="badge bg-outline-primary">
                  Notify
                </div>
              </div>
            </div>
          </div> */}
        </Card.Body>
      </Card>
    </div >
  )
};

export default Events;